export const SmallPictureSuffix = "__small";
export const LargePictureSuffix = "__large";
export const ThumbnailPictureSuffix = "__thumbnail";
export const ENCRYPTED_PREFIX = 'encrypted';
export const CURRENT_STORAGE_VERSION = 'v1';